import { customTime } from "./CustomTime";
import { LocalStorage } from "@Core/storages/local/LocalStorage";
import { JsCookie } from "./JsCookie";
class CookieDublicator {
    constructor() {
        this.safariCookieMaxAge = 604800000; //7 days
        this.prefix = 'nxt_';
        this.localStorage = new LocalStorage();
    }
    dublicateCookieToLocalStorageIfItNeed(key, value, attributes) {
        if (!this.isDublicateToLocalStorage(key, value, attributes) || value == '') {
            this.localStorage.delete(this.prefix + key);
            return false;
        }
        const cookie = Object.assign({}, attributes);
        cookie['key'] = key;
        cookie['value'] = value;
        this.localStorage.set(this.prefix + key, cookie);
    }
    dublicateLocalStorageToCookieIfItNeed(key, attributes) {
        if (!this.isDublicateToCookie(key)) {
            return false;
        }
        let cookie, cookieAge;
        try {
            cookie = this.getStoredValue(key);
            cookieAge = new Date(cookie.expires);
        }
        catch (e) {
            this.localStorage.delete(this.prefix + key);
            return false;
        }
        if (this.isOutDatedLocalStorage(cookieAge)) {
            this.localStorage.delete(this.prefix + key);
            return false;
        }
        delete attributes.key;
        delete attributes.value;
        attributes.expires = cookieAge;
        return JsCookie.getInstance().set(key, cookie.value, attributes);
    }
    getStoredValue(key) {
        return this.localStorage.get(this.prefix + key);
    }
    removeLocalStorageDublicate(key) {
        this.localStorage.delete(this.prefix + key);
    }
    isDublicateToCookie(key) {
        // return userAgent.isSafari();
        return true;
    }
    isDublicateToLocalStorage(key, value, attributes) {
        if (this.isDublicateToCookie(key)) {
            const date = attributes.expires ? new Date(attributes.expires) : customTime.get();
            return this.isDublicateSafari(date);
        }
        return false;
    }
    isDublicateSafari(cookieAge) {
        return cookieAge.getTime() > (customTime.get()).getTime() + this.safariCookieMaxAge;
    }
    stringifyAttributes(attributes) {
        let stringifiedAttributes = attributes.key + '=' + attributes.value;
        delete attributes.key;
        delete attributes.value;
        for (let attributeName in attributes) {
            if (!attributes[attributeName]) {
                continue;
            }
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) {
                continue;
            }
            stringifiedAttributes += '=' + attributes[attributeName];
        }
        return stringifiedAttributes;
    }
    isOutDatedLocalStorage(cookieAge) {
        return customTime.get().getTime() >= cookieAge.getTime();
    }
}
;
export const cookieDublicator = new CookieDublicator();
